import React from 'react';
import { AddButton } from '../AddButton';
import messages from '../ManageServices.messages';

const ResourcesAddButton = () => {
  return <AddButton message={messages.addBtn.resource} />;
};

export default ResourcesAddButton;
